// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__BIK_3","error":"Checkbox_error__CO9Ro","disabled":"Checkbox_disabled__H2Z1L"};